<template>
    <div class="laypanel" style="margin: 40px;">
      <el-tabs v-model="sendmsgtab"  @tab-click="qbclick">
        <el-tab-pane label="行业设定" name="hysd">
          <el-row class="websitequerypanel">
            <el-form label-width="150px" label-position="left" >
              <el-col :span="12">
                <el-form-item label="主营行业:">
                  <el-select v-model="zhuno" placeholder="请选择">
                    <el-option
                      v-for="item in hylist"
                      :key="item.value"
                      :label="item.fhy"
                      :value="item.value">
                      <span style="float: left">{{ item.fhy }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.zhy }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="第二行业:">
                  <el-select v-model="funo" placeholder="请选择">
                    <el-option
                      v-for="item in hylist"
                      :key="item.value"
                      :label="item.fhy"
                      :value="item.value">
                      <span style="float: left">{{ item.fhy }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.zhy }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
          <el-row>
            <el-button style="margin-top: 10px" @click="sethangye">设定行业</el-button>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="模板设定" name="mbsd">
          <el-row class="websitequerypanel">
            <el-table
              fit
              :data="tmplistdata"
              ref="multipleTable">
              <el-table-column
                prop="template_id"
                label="模板ID">
              </el-table-column>
              <el-table-column
                prop="title"
                width="180px"
                label="模板名称">
              </el-table-column>
              <el-table-column
                prop="primary_industry"
                label="主行业">
              </el-table-column>
              <el-table-column
                prop="deputy_industry"
                label="副行业">
              </el-table-column>
              <el-table-column
                prop="content"
                label="模板内容">
              </el-table-column>
              <el-table-column
                prop="example"
                label="例子">
              </el-table-column>
              <el-table-column
                label="操作"
                width="80px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="删除模板" placement="top-start">
                    <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_tmp(scope.$index, tmplistdata)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row class="websitequerypanel">
            <el-form label-width="150px" label-position="left" >
              <el-col :span="12">
                <el-form-item label="模板编号:">
                  <el-input
                    type="text"
                    autosize=""
                    placeholder="请输入短模板ID（TM开头）"
                    v-model="mobaono">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
          <el-row>
            <el-button style="margin-top: 10px" @click="addtmpid">添加消息模板</el-button>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="发送消息" name="fsxx">
          <el-table
            stripe
            :data="hydata"
            ref="kqtb_userlist">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              min-width="30px"
              prop="openid"
              label="OpenId"
            >
            </el-table-column>
            <el-table-column
              prop="usernick.String"
              label="会员昵称">
            </el-table-column>
            <el-table-column
              label="头像">
              <template slot-scope="scope">
                <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
                  <img :src="scope.row.userimg.String" class="avatarimg">
                </div>
                <div v-else>
                  {{scope.row.userimg.String}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="发送推送消息" placement="top-start">
                  <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="sendmsginfoex(scope.$index, hydata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="发送模板消息" :visible.sync="sendmsgvis">
            <el-row>
              <el-col :span="14">
                <el-table
                  :data="tmplistdata"
                  highlight-current-row
                  ref="multipleTable">
                  <el-table-column
                    prop="content"
                    label="模板内容">
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="80px"
                  >
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="选取模板" placement="top-start">
                        <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="seltmp(scope.$index, tmplistdata)"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="10">
                <el-form style="margin-top: 20px; margin-left: 20px;" ref="form"  label-width="120px" label-position="left">
                  <el-form-item label="URL：">
                    <el-input  v-model="urlinfo" placeholder="请输入urlinfo"></el-input>
                  </el-form-item>
                  <el-form-item label="First:">
                    <el-input v-model="firstinfo" placeholder="请输入First"></el-input>
                  </el-form-item>
                  <el-form-item label="KeyWord1:">
                    <el-input v-model="keyword1" placeholder="请输入KeyWord1"></el-input>
                  </el-form-item>
                  <el-form-item label="KeyWord2:">
                    <el-input v-model="keyword2" placeholder="请输入KeyWord2"></el-input>
                  </el-form-item>
                  <el-form-item label="KeyWord3:">
                    <el-input v-model="keyword3" placeholder="请输入KeyWord3"></el-input>
                  </el-form-item>
                  <el-form-item label="KeyWord4:">
                    <el-input v-model="keyword4" placeholder="请输入KeyWord4"></el-input>
                  </el-form-item>
                  <el-form-item label="ReMark:">
                    <el-input v-model="remark" placeholder="请输入ReMark"></el-input>
                  </el-form-item>
                  <div style="color: darkgreen;">
                    <span>{{seltmptitle}}</span>
                  </div>
                  <div style="color: darkgreen; margin-top: 10px;">
                    <span>{{seltmpcontext}}</span>
                  </div>
                  <el-button style="margin-top: 20px;" @click="sendmsgok">发送模板消息</el-button>
                </el-form>
              </el-col>
            </el-row>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="订阅通知" name="dytz">
          <el-row>
            <el-col :span="24">
              <el-table
                stripe
                :data="dydata">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="tid"
                  label="TID"
                >
                </el-table-column>
                <el-table-column
                  prop="title"
                  label="标题">
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="模板类型">
                </el-table-column>
                <el-table-column
                  prop="categoryId"
                  label="所属类目">
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="120px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="选取模板" placement="top-start">
                      <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="xqmb(scope.$index, dydata)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <el-dialog title="模板制定" :visible.sync="mbzdvis">
                <el-row>
                  <el-table
                    :data="tmpkeydata"
                    ref="tmpkeyref"
                    highlight-current-row>
                    <el-table-column
                      type="selection"
                      width="55">
                    </el-table-column>
                    <el-table-column
                      prop="kid"
                      label="KID">
                    </el-table-column>
                    <el-table-column
                      prop="name"
                      label="字段名">
                    </el-table-column>
                    <el-table-column
                      prop="rule"
                      label="字段格式">
                    </el-table-column>
                    <el-table-column
                      prop="example"
                      label="例子">
                    </el-table-column>
                  </el-table>
                </el-row>
                <el-button style="margin-top: 20px;" @click="savemytmp">添加到私自模板</el-button>
              </el-dialog>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="已订阅通知" name="ydytz">
          <el-row>
            <el-table
              stripe
              :data="ydydata">
              <el-table-column
                prop="priTmplId"
                label="私有模板ID"
              >
              </el-table-column>
              <el-table-column
                prop="title"
                label="标题">
              </el-table-column>
              <el-table-column
                prop="content"
                label="内容">
              </el-table-column>
              <el-table-column
                label="操作"
                width="120px"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="删除模板" placement="top-start">
                    <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="delmytmp(scope.$index, ydydata)"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'WxSendMsg',
  data () {
    return {
      khid: '',
      urlinfo: '',
      firstinfo: '',
      keyword1: '',
      keyword2: '',
      keyword3: '',
      keyword4: '',
      remark: '',
      pagecontext: '',
      sendmsgtab: 'hysd',
      zhuno: '',
      funo: '',
      tmplistdata: [],
      tmpkeydata: [],
      mbzdvis: false,
      dydata: [],
      ydydata: [],
      hylist: [
        {
          value: 1,
          zhy: 'IT科技',
          fhy: '互联网/电子商务'
        },
        {
          value: 2,
          zhy: 'IT科技',
          fhy: 'IT软件与服务'
        },
        {
          value: 3,
          zhy: 'IT科技',
          fhy: 'IT硬件与设备'
        },
        {
          value: 4,
          zhy: 'IT科技',
          fhy: '电子技术'
        },
        {
          value: 5,
          zhy: 'IT科技',
          fhy: '通信与运营商'
        },
        {
          value: 6,
          zhy: 'IT科技',
          fhy: '网络游戏'
        },
        {
          value: 7,
          zhy: '金融业',
          fhy: '银行'
        },
        {
          value: 8,
          zhy: '金融业',
          fhy: '基金理财信托'
        },
        {
          value: 9,
          zhy: '金融业',
          fhy: '保险'
        },
        {
          value: 10,
          zhy: '餐饮',
          fhy: '餐饮'
        },
        {
          value: 11,
          zhy: '酒店旅游',
          fhy: '酒店'
        },
        {
          value: 12,
          zhy: '酒店旅游',
          fhy: '旅游'
        },
        {
          value: 13,
          zhy: '运输与仓储',
          fhy: '快递'
        },
        {
          value: 14,
          zhy: '运输与仓储',
          fhy: '物流'
        },
        {
          value: 15,
          zhy: '运输与仓储',
          fhy: '仓储'
        },
        {
          value: 16,
          zhy: '教育',
          fhy: '培训'
        },
        {
          value: 17,
          zhy: '教育',
          fhy: '院校'
        },
        {
          value: 31,
          zhy: '消费品',
          fhy: '消费品'
        },
        {
          value: 32,
          zhy: '商业服务',
          fhy: '法律'
        },
        {
          value: 33,
          zhy: '商业服务',
          fhy: '会展'
        },
        {
          value: 35,
          zhy: '商业服务',
          fhy: '认证'
        },
        {
          value: 36,
          zhy: '商业服务',
          fhy: '审计'
        },
        {
          value: 37,
          zhy: '文体娱乐',
          fhy: '传媒'
        },
        {
          value: 38,
          zhy: '文体娱乐',
          fhy: '体育'
        }
      ],
      mobaono: '',
      sendmsgvis: false,
      selsenduser: '',
      seltmpinfo: '',
      seltmpid: '',
      selmytmptitle: '',
      seltmptitle: '',
      seltmpcontext: '',
      hydata: [],
      accesstoken: ''
    }
  },
  mounted: async function () {
    that = this
    var at = await getaccesstoken()
    that.accesstoken = at
    that.gettmplist()
    that.getgktmplist()
    that.getydytmp()
    that.getmemberlist()
  },
  methods: {
    delmytmp (index, data) {
      var tmpdata = data[index]
      var ddata = {
        priTmplId: tmpdata.priTmplId,
        accesstoken: that.accesstoken
      }
      window.console.log(ddata)
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/delmytmp',
        method: 'post',
        data: ddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            if (tmpdata.errcode === 0) {
              that.$message.success('删除模板完毕')
              that.getydytmp()
            }
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    savemytmp () {
      var kids = []
      for (var index in that.$refs.tmpkeyref.selection) {
        kids.push(that.$refs.tmpkeyref.selection[index].kid)
      }
      window.console.log(kids)
      window.console.log(that.seltmpid)
      window.console.log(that.selmytmptitle)
      var adata = {
        tid: that.seltmpid.toString(),
        kidList: kids,
        sceneDesc: that.selmytmptitle.toString(),
        accesstoken: that.accesstoken
      }
      window.console.log(adata)
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/addtomytmp',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            if (tmpdata.errcode === 0) {
              that.$message.success('添加模板完毕')
              that.getydytmp()
            }
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    getgktmplist () {
      var qdata = {
        ids: '782,413',
        start: '0',
        limit: '30',
        accesstoken: that.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getpubtmplist',
        method: 'post',
        data: qdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            that.dydata = tmpdata.data
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    getydytmp () {
      var adata = {
        accesstoken: that.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/getmytmp',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            that.ydydata = tmpdata.data
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    gettmplist () {
      var adata = {
        accesstoken: that.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/gettmplist',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            window.console.log(res)
            var tmpdata = JSON.parse(res.data.data)
            that.tmplistdata = tmpdata.template_list
            // 把相关数据缓存到本地
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    getmemberlist: function () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/member/gbuw',
        method: 'post',
        data: {
          whereinfo: {String: ' openid is not null ', Valid: true},
          accesstoken: that.accesstoken
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.hydata = JSON.parse(res.data.data)
            // 把相关数据缓存到本地
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    sethangye: function () {
      window.console.log(that.zhuno)
      window.console.log(that.funo)
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/sethy',
        method: 'post',
        data: {
          industryid1: that.zhuno.toString(),
          industryid2: that.funo.toString(),
          accesstoken: that.accesstoken
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            // 把相关数据缓存到本地
            that.$message('行业已设定完成')
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    addtmpid: function () {
      var addtmp = {
        template_id_short: that.mobaono.toString(),
        accesstoken: that.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/addtmpinfo',
        method: 'post',
        data: addtmp,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            // 把相关数据缓存到本地
            that.$message.success('添加完毕')
            that.gettmplist()
            window.console.log(res.data.data)
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    qbclick (tab, event) {
      console.log(tab)
    },
    del_tmp (index, data) {
      var deldata = {
        template_id: data[index].template_id,
        accesstoken: that.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/deltmpinfo',
        method: 'post',
        data: deldata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            // 把相关数据缓存到本地
            that.$message.success('删除成功')
            that.gettmplist()
            window.console.log(res.data.data)
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    sendmsginfoex (index, data) {
      that.selsenduser = data[index]
      that.sendmsgvis = true
    },
    xqmb (index,data) {
      var tmpdata = data[index]
      that.gettmpbykey(tmpdata.tid)
      that.selmytmptitle = tmpdata.title
    },
    gettmpbykey (tid) {
      that.seltmpid = tid
      var qdata = {
        tid: tid.toString(),
        accesstoken: that.accesstoken
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/gettmpbykey',
        method: 'post',
        data: qdata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            var tmpdata = JSON.parse(res.data.data)
            window.console.log(tmpdata)
            that.tmpkeydata = tmpdata.data
            that.mbzdvis = true
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    seltmp (index, data) {
      that.seltmpinfo = data[index]
      that.seltmptitle = that.seltmpinfo.title
      that.seltmpcontext = that.seltmpinfo.content
    },
    sendmsgok () {
      window.console.log(that.selsenduser)
      window.console.log(that.seltmpinfo)
      var senddata = {
        accesstoken: that.accesstoken,
        touser: that.selsenduser.openid,
        template_id: that.seltmpinfo.template_id,
        url: that.urlinfo,
        data: {
          keyword1: {value: that.keyword1},
          keyword2: {value: that.keyword2},
          keyword3: {value: that.keyword3},
          keyword4: {value: that.keyword4}
        },
        color: '#000000'
      }
      that.$http({
        url: 'https://wx.sqnetsoft.cn/wx/sendtmpmsg',
        method: 'post',
        data:senddata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.result === 'success') {
            that.$message.success('发送成功')
          }
          window.console.log(res)
        })
        .catch(function (error) {
          window.console.log('error' + error)
        })
    }
  }
}
async function getaccesstoken () {
  return new Promise(resolve => {
    that.$http({
      url: 'https://wx.sqnetsoft.cn/wx/getaccesstoken',
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        window.console.log(res)
        if (res.status === 200) {
          window.console.log(res.data)
          resolve(res.data)
        } else {
          window.console.log('返回错误')
          resolve('')
        }
      })
      .catch(function (error) {
        window.console.log(error)
        resolve('')
      })
  })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/wx/WxSendMsg.vue